import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {OrderDetailFeature} from "./OrderDetailFeature";
import {observer} from "mobx-react";
import useFeature from "../../../useFeature";
import {useApplication} from "../../../ApplicationProvider";
import MoneyRenderer from "../../utils/MoneyRenderer";


const OrderDetailScreen = () => {
    const application = useApplication();
    const navigator = useNavigate();
    const {id} = useParams();
    const feature = useFeature(() => new OrderDetailFeature(application, navigator, id))
    const handleVerMas = async () => {
        // TODO will orders be paginated?
    };

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    return isFeatureReady(feature) && (
        <div className="container">
            <div className="row">
                <div className="col-sm-10 col-sm-offset-1">
                    <div className="text-center margintop60">
                        <div className="text-center margintop30">
                            <div className="margintop60 hidden-xs"></div>
                            <h3>Detalle Pedido</h3>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="container-info-pedido reclamo">
                                    <div className="row">
                                        <div className="col-sm-8">
                                            <div className="datos-pedido">
                                                <div className="row datos-pedido-box">
                                                    <div className="col-xs-4 col-sm-3">
                                                        <div className="item-box">
                                                            <p className="general-title text-right-left">Punto de entrega</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-1 col-sm-1">
                                                        <div className="item-box">
                                                            <span className="label label-default font10">{feature.deliverySiteName()}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row datos-pedido-box">
                                                    <div className="col-xs-4 col-sm-3">
                                                        <div className="item-box">
                                                            <p className="general-title text-right-left">Número de orden de compra</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-1 col-sm-1">
                                                        <div className="item-box" style={{fontFamily: 'ArcherSmbd, sans-serif', fontSize: '16px', alignItems: "center"}}>
                                                            <p className="descripcion-item-box">{feature.order().customersOrderNumber || "-" }</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row datos-pedido-box">
                                                    <div className="col-xs-4 col-sm-3">
                                                        <div className="item-box">
                                                            <p className="general-title text-right-left">Fecha de
                                                                Pedido</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-8 col-sm-9">
                                                        <div className="item-box">
                                                            <p className="descripcion-item-box">{feature.order().deliveryDate}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row datos-pedido-box">
                                                    <div className="col-xs-4 col-sm-3">
                                                        <div className="item-box">
                                                            <p className="general-title text-right-left">Estado</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-1 col-sm-1">
                                                        <div className="item-box">
                                                            <span className="label label-default font10">{feature.order().state}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="table-responsive margintop40 hidden-xs">
                            <table className="table table-pedidos">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th style={{textAlign: 'left'}}>ARTICULOS</th>
                                    <th style={{textAlign: 'center'}}>PRECIO UNITARIO</th>
                                    <th style={{textAlign: 'center'}}>CANTIDAD DE CAJAS</th>
                                    <th style={{textAlign: 'center'}}>CONTENIDO CAJA</th>
                                    <th style={{textAlign: 'center'}}>TOTAL</th>

                                </tr>
                                </thead>
                                <tbody id="tbody">
                                {feature.order().articles.map((article, index) => (
                                    <ArticleItem key={index} article={article}
                                                 feature={feature}/>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="totales-container">
                            <table className="table-totales">
                                <tbody>
                                <tr>
                                    <td className="text-right">SUBTOTAL</td>
                                    <td className="text-right">{MoneyRenderer(feature.subtotal())}</td>
                                </tr>
                                <tr>
                                    <td className="text-right">IVA</td>
                                    <td className="text-right">{MoneyRenderer(feature.totalTaxes())}</td>
                                </tr>
                                <tr>
                                    <td className="text-right">IIBB</td>
                                    <td className="text-right">{MoneyRenderer(feature.totalGrossIncomeTaxes())}</td>
                                </tr>
                                <tr className="total-row">
                                    <td className="text-right">TOTAL</td>
                                    <td className="text-right">{MoneyRenderer(feature.total())}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="clearfix"></div>

                        <hr className="margintop30 full-xs"/>

                        {!feature.orderIsInvoiced() && (
                            <div style={{marginTop: '20px', fontSize: '0.85rem', color: '#666', fontStyle: 'italic', textAlign: 'left', padding: '0 15px'}}>
                                * Los precios, impuestos y la disponibilidad de los productos exhibidos son estimativos y podrán modificarse sin previo aviso; el monto definitivo será el indicado en la factura correspondiente.
                            </div>
                        )}
                    </div>
                </div>
                <hr className="divider-line footer-line hidden-xs"/>
            </div>
        </div>
    )
};


const ArticleItem = ({article, feature}) => {
    /*
        const isFacturado = article.state === 'Facturado';
        const maxPaginas = 5;
        const pagina = 1;
    */
    return (
        <>
            <tr>
                <td style={{textAlign: 'left'}}>
                    <img src={feature.productImage(article)} className="img-responsive img-order-product" alt="Foto de Producto"/>
                </td>
                <td style={{textAlign: 'left'}}>{article.fantasyName}</td>
                <td style={{textAlign: 'center'}}>{feature.unitPriceOf(article)}</td>
                <td style={{textAlign: 'center'}}>{feature.amountOf(article)}</td>
                <td style={{textAlign: 'center'}}>{feature.unitsPerAmountOf(article)} {feature.itemUnitAbbreviation(article)}</td>
                <td style={{textAlign: 'left'}}>{MoneyRenderer(feature.totalForArticle(article))}</td>
            </tr>
            {/*
            {maxPaginas < pagina && (
                <script type="text/javascript">
                    {`document.querySelector('[boton-ver-mas]').style.display = 'none';`}
                </script>
            )}*/}
        </>
    );
};
/*

const ModalRepetirPedido = ({order, onClose}) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    return order && (
        <div>
            <Modal
                open={true}
                onClose={onClose}
                aria-labelledby="modal-repetir-pedido-title"
                aria-describedby="modal-repetir-pedido-description"
            >
                <Box sx={style}>
                    <Typography variant="h6" component="h2" id="modal-repetir-pedido-title">
                        <Button onClick={handleClose} style={{float: 'right'}}>
                            Cerrar <FontAwesomeIcon icon={faTimesCircle}/>
                        </Button>
                    </Typography>
                    <Typography variant="body1" component="div" id="modal-repetir-pedido-description">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="text-center">
                                        <Typography variant="h4">Tiene artículos en el carrito ¿qué desea
                                            hacer?</Typography>
                                    </div>
                                </div>
                            </div>
                            <div className="row margintop40">
                                <div className="col-xs-12">
                                    <div className="modal-actions">
                                        <Button variant="contained" color="primary"
                                                href={`/Pedido/SumarPedidoActual/?pedidoId=${pedido.id}`}>
                                            Sumar al carrito
                                        </Button>
                                        <Button variant="outlined" color="secondary"
                                                href={`/Pedido/DescartarPedidoActual/?pedidoId=${pedido.id}`}
                                                style={{marginLeft: 15}}>
                                            Descartar el carrito
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Typography>
                </Box>
            </Modal>
        </div>
    );
};
*/

export default observer(OrderDetailScreen);

